<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">数据中心</Breadcrumb-item>
        <Breadcrumb-item>课程消耗日报列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="50" :show-message="false" label-position="left">
        <Row :gutter="32">
          <Col :span="8" >
            <Form-item label="时间:">
              <Row>
                <Col span="11">
                  <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期" value-format="yyyy-MM-dd" v-model="queryParam.startDate" style="width: 100%;"/>
                </Col>
                <Col span="2" style="text-align: center">-</Col>
                <Col span="11">
                  <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期" value-format="yyyy-MM-dd" v-model="queryParam.endDate" style="width: 100%;"/>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col :span="4">
            <Form-item label="学导：">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.studyConsultantId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search" >搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
                    @click="exportData">导出
            </Button>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/dataCenter/lessonDailyList"
          :params="queryParam" :onLoading="onLoading"></List>
  </div>
</template>

<script>
    export default {
      components: {

      },
      name: 'lessonExpendDailyList',
      data () {
        return {
          exportLoading: false,
          searchLoading: false,
          reload: 0,
          queryParam: {
            startDate: null,
            endDate: null,
            studyConsultantId: null
          },
          title: [
            {
              title: '日期',
              // width: 130,
              align: 'center',
              key: 'statisticalDate'
            },
            {
              title: '一对一外教课时',
              align: 'center',
              // width: 170,
              key: 'enCountSum',
            },
            {
              title: '中教',
              // width: 120,
              align: 'center',
              key: 'cnCountSum'
            },
            {
              title: '陪练',
              // width: 120,
              align: 'center',
              key: 'partnerSum'
            },
            {
              title: '学生提前请假',
              // width: 150,
              align: 'center',
              key: 'studentAskLeaveCountSum'
            },
            {
              title: '学生临时请假',
              // width: 150,
              align: 'center',
              key: 'studentOnLeaveCountSum'
            },
            {
              title: '补课',
              // width: 120,
              align: 'center',
              key: 'makeUpCountSum'
            },
            {
              title: '学生缺席',
              // width: 120,
              align: 'center',
              key: 'studentAbsentCountSum'
            },
            {
              title: '老师缺席',
              // width: 120,
              align: 'center',
              key: 'teacherAbsentCountSum'
            }
          ]
        }
      },
      mounted: function () {
        this.init()
      },
      created: function () {
        this.init()
      },
      methods: {
        init () {

        },
        exportData () {
          this.exportLoading = true
          this.$http.get('/dataCenter/lessonDaily/exportExcel', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
            if (response.data) {
              let blob = new Blob([response.data], {type: 'text/csv'})
              let link = document.createElement('a')
              link.target = '_blank'
              link.href = window.URL.createObjectURL(blob)
              link.download = '课耗统计.csv'
              link.click()
              this.exportLoading = false
            } else {
              this.$Message.error(response.msg)
            }
          }).catch((e) => {
            this.exportLoading = false
          })
        },
        search () {
          this.reload = new Date().getTime()
        },
        onLoading (loading) {
          this.searchLoading = loading
        },
      },
    }
</script>

<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
</style>


// WEBPACK FOOTER //
// LessonExpendDailyList.vue?2ef8aada